export default {
    page_title: "Kevi | Campos del presupuesto",
    title: "Campos del presupuesto",
    add_button: "Agregar",
    back_button: "Volver",
    save_button: "Guardar",
    create_form_title: "Creando campo",
    field_form: {
        name_label: "Nombre",
        type_label: "Tipo",
    },
    tooltips: {
        edit_field: "Editar campo",
        delete_field: "Eliminar campo",
    },
    delete_modal: {
        title: "¿Le gustaría eliminar",
        body_standard:
            "Esta acción es irreversible, ¿está seguro de que desea continuar?",
        body_linked: "Este campo está vinculado a",
        automations: "las siguientes automatizaciones:",
        segments: "los siguientes segmentos:",
        warning:
            "Se recomienda ajustar antes de eliminar, continuar ahora puede generar resultados inesperados.",
    },
    edit_modal: {
        title: "¿Le gustaría editar el nombre para",
        body: "Asegúrese de que el nuevo nombre sea correcto antes de confirmar.",
    },
    notifications: {
        added: "Campo agregado",
        deleted: "Campo de presupuesto eliminado",
        edited: "Campo de presupuesto editado",
    },
};
